import { connect } from 'react-redux';

import CustomerList from '../components/Customers';
import { State } from '../../../reducer';
import { getCustomers, getCustomersCount } from '../actions';
import { getCustomersSelector } from '../selectors';

const mapStateToProps = (state: State) => ({
    customers: getCustomersSelector(state),
});

const mapDispatchToProps = {
    getCustomers,
    getCustomersCount,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomerList);
